import { action, makeObservable, observable } from 'mobx';

import { ConnectRootStore } from '../../utils/connectRootStore';
import { DashboardRootStore } from '../../dashboard.store';
import { UserInfo } from '../../../../services/partnerUser.service';

export class UserStore extends ConnectRootStore<DashboardRootStore> {
    @observable userInfo: UserInfo = {} as UserInfo;

    constructor(root: DashboardRootStore) {
        super(root);
        makeObservable(this);
    }

    @action
    public setUserInfo(info: UserInfo) {
        this.userInfo = info;
    }
}
